module.exports = __webpack_public_path__ + "media/images/footer_blog-1d6b39333ea0c73b97266b017705d27b.png";